// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { defineComponent } from '../../utils/define-component';
import { useGlyph } from './use-glyph';

/**
 * Inline HTML **character reference** as plain text (e.g. next to `Lorem` /
 * `Ipsum`). Icons use `Icon` / app-icon elsewhere; `Glyph` is only for character
 * references.
 *
 * @remarks
 * The view renders `content` from setup (repeated reference strings or `null`).
 * Pass `id`, `decimal`, or `hex` per {@link GlyphProps}. Optional `repeat` defaults
 * to `1` (see {@link useGlyph}).
 * @example
 *
 * ```tsx
 * Lorem<Glyph id="Blank" />Ipsum
 * <Glyph decimal={8212} />
 * <Glyph hex="2014" repeat={1} />
 * ```
 *
 * @see {@link useGlyph}
 * @see {@link GlyphsMap} in `./glyphs`
 */
export const Glyph = defineComponent({
  displayName: 'Glyph',
  useSetup: useGlyph,
  View: ({ content }) => content,
});
